<template>
  <div class="panel-list-page">
    <div class="pl-card">
      <div class="pl-card__header">
        <div class="pl-card__title-wrap">
          <span class="pl-card__icon" aria-hidden="true">
            <CIcon name="navProducts"/>
          </span>
          <div>
            <h1 class="pl-card__title">لیبل‌ها</h1>
            <p class="pl-card__sub">مدیریت لیبل‌های محصولات</p>
          </div>
        </div>
        <div class="pl-toolbar">
          <button type="button" class="pl-btn pl-btn--primary" @click="openCreateModal()">
            <CIcon name="iconPlus"/>
            <span>افزودن لیبل جدید</span>
          </button>
        </div>
      </div>

      <div class="pl-card__body">
        <CDataTableFixed
          class="pl-table"
          :items="items"
          :fields="fields"
          :items-per-page="20"
          hover
          sorter
          pagination
          :noItemsView="{ noItems: 'لیبلی یافت نشد' }"
        >
          <template #no-items-view>
            <div class="pl-empty">
              <span class="pl-empty__icon" aria-hidden="true">
                <CIcon name="navProducts"/>
              </span>
              <p class="pl-empty__title">لیبلی یافت نشد</p>
              <p class="pl-empty__sub">برای شروع، یک لیبل جدید اضافه کنید.</p>
              <button type="button" class="pl-btn pl-btn--primary" @click="openCreateModal()">
                <CIcon name="iconPlus"/>
                <span>افزودن لیبل جدید</span>
              </button>
            </div>
          </template>

          <template #row="{ item }">
            <td>
              <span class="pl-muted">{{ item.row_id + 1 }}</span>
            </td>
          </template>

          <template #name="{ item }">
            <td>
              <span class="pl-name">{{ item.name }}</span>
            </td>
          </template>

          <template #color="{ item }">
            <td>
              <span class="pl-color-swatch">
                <span class="pl-color-swatch__dot" :style="{ backgroundColor: item.color }"/>
                <span>{{ item.color }}</span>
              </span>
            </td>
          </template>

          <template #operation="{ item }">
            <td class="pl-ops-cell">
              <div class="pl-ops">
                <button type="button" class="pl-icon-btn pl-icon-btn--warn" title="ویرایش" @click="openEditModal(item)">
                  <CIcon name="iconEdit"/>
                </button>
                <button type="button" class="pl-icon-btn pl-icon-btn--danger" title="حذف" @click="delete_item_dialog(item)">
                  <CIcon name="iconTrash"/>
                </button>
              </div>
            </td>
          </template>
        </CDataTableFixed>
      </div>
    </div>

    <CModal
      :show.sync="form_modal"
      :centered="true"
      size="md"
      :title="status_form == 0 ? 'افزودن لیبل جدید' : 'ویرایش لیبل'"
      @update:show="onFormModalToggle"
    >
      <div class="pl-form">
        <CRow>
          <CCol col="12">
            <CInput
              v-model="name"
              class="required"
              label="نام"
              placeholder="نام"
            />
          </CCol>
          <CCol col="12">
            <CInput
              v-model="color"
              label="رنگ"
              type="color"
            />
          </CCol>
        </CRow>
      </div>
      <template #footer>
        <button type="button" class="pl-btn pl-btn--ghost" @click="closeFormModal()">انصراف</button>
        <button type="button" class="pl-btn pl-btn--primary" @click="login()">
          <CIcon name="iconCheck"/>
          <span>{{ status_form == 0 ? 'ثبت لیبل' : 'ذخیره تغییرات' }}</span>
        </button>
      </template>
    </CModal>
  </div>
</template>

<script>
import axios from "axios";

import {bus} from '../../main';


export default {
  name: 'Login',
  data() {
    return {
      form_modal: false,
      confirm_delete_name:new Date().getTime()+"_"+this.$vnode.tag,
      name: '',
      file: null,
      color: '#000000',
      previewImage: null,
      description: '',
      items: [],
      fields: [
        {key: 'row', label: '#', _style: 'width:5%'},
        {key: 'name', label: 'نام', _style: 'width:25%'},
        {key: 'color', label: 'رنگ', _style: 'width:15%'},
        {key: 'operation', label: 'عملیات', _style: 'width:10%'},
      ],

      status_form: 0,

    }
  }, mounted() {
    this.get_categories();
    bus.$on(this.confirm_delete_name, (data) => {
      // alert(data);
      if (data == "true") {
        this.delete_item();

      } else {
        this.status_form = 0;
      }
    });
  }, watch: {
    '$route.params.cat_id': function () {
      this.get_categories();
    }
  },
  methods: {

    openCreateModal() {
      this.cancel_form();
      this.form_modal = true;
    },
    openEditModal(item) {
      this.editDetails(item);
      this.form_modal = true;
    },
    closeFormModal() {
      this.form_modal = false;
      this.cancel_form();
    },
    onFormModalToggle(show) {
      if (!show) {
        this.cancel_form();
      }
    },
    cancel_form() {
      this.name = ''
      this.color = ''
      this.description = ''
      this.previewImage =  ''

      this.status_form = 0

    }, editDetails(item) {
      this.name = item.name;
      this.color = item.color;
      this.description = item.description;
      this.previewImage = item.image;

      this.status_form = item.id;

    },
    get_categories() {
      var self = this;
      var formData = new FormData();
      formData.append('cat_id', this.$route.params.cat_id)
      axios.post('/api/admin/product/get_label',formData, {}).then(function (response) {

        var content_cats = response.data;

        // items = content_cats.orders;
        self.items = content_cats.orders.map((item, row_id) => {
          return {...item, row_id}
        })
      })
          .catch(function (error) {

            console.log(error);
          });

    },

    login() {


      let self = this;
      const formData = new FormData()
      let url;
      if (this.status_form == 0) {
        url = "/api/admin/product/insert_label";
      } else {
        url = "/api/admin/product/update_label";
        formData.append('id', this.status_form)

      }

      formData.append('color', this.color);

      formData.append('name', this.name);
      axios.post(url, formData, {}).then((res) => {

        self.$root.modal_component.show_api_response_modals(res);

        if (res.data.error == 0) {
          self.name = '';
          self.color = '';
          self.description = '';
          self.previewImage = '';
          self.previewImage_header = '';
          self.status_form = 0;
          self.form_modal = false;
          self.get_categories();
        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    delete_item_dialog(item) {
      this.$root.modal_component.show_confirm_modal(this.$t("warning"), this.$t("deleteMessage"), [this.$t("ok")], this.confirm_delete_name);

      this.status_form = item.id;

    },
    delete_item() {


      let self = this;
      const formData = new FormData()
      let url;
      url = "/api/admin/product/delete_label";


      formData.append('id', this.status_form);

      axios.post(url, formData, {}).then((res) => {

        self.$root.modal_component.show_api_response_modals(res);
        self.status_form = 0;

        self.get_categories();


      })
          .catch(function (error) {
            console.log(error);
          });
    },
  }
}


</script>
